import React, { Component } from 'react';
import { Container, Row, Col } from "reactstrap";
import 'moment/locale/id';
import Events from '../Events';

class Section extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            height:window.innerHeight,
            listSchedulle: [],
        }
    }
    
    render() {
        return (
            <React.Fragment>
                <section className="home bg-home" id="home">
                  <Container>
                    <Row>
                      <Col lg='8'>
                        <h1>Kuliah Keluar Negeri,</h1>
                        <h1>Dimulai dari Sini!</h1>
                        <ul>
                          <li>Tanya jawab langsung, konsultasi gratis, dan buka wawasanmu</li>
                          <li>Biar Gak Salah Jurusan & Negara</li>
                        </ul>
                      </Col>
                    </Row>
                    <Row className='credible mt-3 text-center'>
                      <Col md='3' xl='3'><h2>15<sup>th</sup></h2><p>Pengalaman</p></Col>
                      <Col md='3' xl='3'><h2>20+</h2><p>Negara</p></Col>
                      <Col md='3' xl='3'><h2>250+</h2><p>Universitas</p></Col>
                      <Col md='3' xl='3'><h2>1000+</h2><p>Program & Jurusan</p></Col>
                    </Row>                    
                  </Container>
                  <div className="triangle"></div>
                </section>             
                <Events />
            </React.Fragment>
        );
    }
}

export default Section;